import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { PDialogFooterBtnActionType } from './p-dialog-footer-btn-config.interface';
import { AlertType } from '../p-snackbar-toaster';

@Component({
    selector: 'pui-edit-link-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header title="Set {{ data.label }}"></p-dialog-header>
            <div class="p-dialog-content">
                <div pLabelAligner=".p-field-label" fxLayout="column" fxLayoutGap="14px" fxLayoutAlign="start stretch">
                    <p-field-text
                        label="{{ 'changeLinkPopup.url' | translate }}"
                        [(ngModel)]="data.href"
                        (enterPressed)="save()"
                        [hasInputListener]="true"
                        (keyup)="urlKeyUp()"
                        [required]="true"
                    ></p-field-text>
                    <p-field-text
                        label="{{ 'changeLinkPopup.text' | translate }}"
                        [(ngModel)]="data.text"
                        (enterPressed)="save()"
                        (keypress)="textKeyPress()"
                    ></p-field-text>
                </div>
            </div>

            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./edit-link-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditLinkDialogComponent {
    private copyHrefToText = false;
    constructor(
        private dialogRef: MatDialogRef<EditLinkDialogComponent>,
        private translateSvc: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: { href: any; text: string; label: string }
    ) {
        this.copyHrefToText = !data.text;
    }

    get footerConfig() {
        return [
            {
                text: 'Actions.save',
                click: () => this.save(),
                disabled: !this.data.href
            },
            {
                type: PDialogFooterBtnActionType.Close
            }
        ];
    }

    public alertData = {
        msgMain: this.translateSvc.instant('changeLinkPopup.errorMsg.emptyUrl'),
        type: AlertType.Error,
        hideCloseBtn: true,
        hideIcon: true
    };

    public save() {
        if (!this.data.href.trim()) {
            return;
        }

        const data = this.addHttpPrefix(this.data);

        this.dialogRef.close(data);
    }

    private addHttpPrefix({ href, text }: any) {
        href = href.trim();

        if (href && !text) {
            text = href;
        }
        if (href && !href.startsWith('http')) {
            href = 'http://' + href;
        }
        return { href, text };
    }

    urlKeyUp() {
        if (this.copyHrefToText) {
            this.data.text = this.data.href;
        }
    }

    textKeyPress() {
        this.copyHrefToText = false;
    }
}
